/* src/modules/lessons/reducers.js */

import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchLessonsTypes,
  fetchLessonTypes,
  fetchUserLessonTypes,
  refundLessonTypes,
  SET_LESSON_PAGE,
  SET_LESSON_PAGE_COUNT,
} from './action_types';

import { ON_ERROR } from '../app_state/action_types';

import { makeRequestReducer } from '../../config/client';
import cardReducer from './cards/LessonCard/reducers';

const initialPaginationState = {
  page: 1,
  currentPageCount: 0,
  limit: 25,
};

const pagination = (state = initialPaginationState, action) => {
  switch (action.type) {
    case SET_LESSON_PAGE:
      return { ...state, page: action.payload };
    case SET_LESSON_PAGE_COUNT:
      return { ...state, currentPageCount: action.payload };
    case ON_ERROR:
    default:
      return state;
  }
};

const main = makeRequestReducer({
  types: fetchLessonsTypes,
  name: 'lessonsAdmin',
  mutate: (state, res) => ({ count: res.count, list: keyBy(res.lessons, '_id') }),
  append: [(state, action) => {
    switch (action.type) {
      case ON_ERROR:
        return { ...state, data: {} };
      default:
        return state;
    }
  }],
});

const single = makeRequestReducer({
  types: fetchLessonTypes,
  name: 'lesson',
  append: [
    makeRequestReducer({
      types: fetchUserLessonTypes,
      name: 'lesson',
    }),
    makeRequestReducer({
      types: refundLessonTypes,
      name: 'refundLesson',
    }),
    (state, action) => {
      switch (action.type) {
        case ON_ERROR:
          return { ...state, data: {} };
        default:
          return state;
      }
    },
  ],
});

export default combineReducers({
  main,
  single,
  card: cardReducer,
  pagination,
});



// WEBPACK FOOTER //
// ./src/modules/lessons/reducers.js